import Link from "next/link";
import type { ReactElement } from "react";
import React from "react";

import { DESO_TOKEN_DISPLAY_NAME, OPENFUND_APP_NAME } from "@/utils/constants";
import type { Maybe, PartialAccount } from "@/utils/types";

import { Button } from "../ui/button";
import { InfoTooltip } from "./info-tooltip";

interface TradeOnOpenfundLinkProps {
  account?: Maybe<PartialAccount>;
  content?: ReactElement<unknown> | string;
  title?: React.ReactNode;
  iconSize?: number;
}

const DEFAULT_TITLE = `Advanced Trading on ${OPENFUND_APP_NAME}`;
const DEFAULT_CONTENT = `All of your assets are trade-able on the ${DESO_TOKEN_DISPLAY_NAME} order-book DEX, accessible via the Openfund client. With Openfund you can place limit orders, view price history, and much more. All 100% on-chain and fully-decentralized thanks to  the ${DESO_TOKEN_DISPLAY_NAME} blockchain.`;

const TradeOnOpenfundLink = ({
  account,
  content,
  title,
  iconSize,
}: TradeOnOpenfundLinkProps) => {
  const linkURL = account?.username
    ? `${process.env.NEXT_PUBLIC_OPENFUND_URI}/trade/${account.username}`
    : `${process.env.NEXT_PUBLIC_OPENFUND_URI}/trade`;

  return (
    <div className="flex items-center">
      <Link href={linkURL} target="_blank">
        <Button
          variant="link"
          size="sm"
          className="flex size-auto bg-transparent px-1 text-xs text-muted"
        >
          {title || DEFAULT_TITLE}
        </Button>
      </Link>
      <InfoTooltip text={content || DEFAULT_CONTENT} iconSize={iconSize} />
    </div>
  );
};

export default TradeOnOpenfundLink;
